import * as yup from 'yup'

export const schema = yup.object().shape({
  acceptType: yup.string().required('Escolha um status'),
})

export default schema
